import pdfmake from 'pdfmake/build/pdfmake.js'
import vfsFonts from '../assets/javascripts/vfs_fonts'
export default {
  install (Vue, options) {
    const { vfs } = vfsFonts.pdfMake
    pdfmake.vfs = vfs
    pdfmake.fonts = {
      Lato: {
        normal: 'Lato-Regular.ttf',
        bold: 'Lato-Bold.ttf',
        italics: 'Lato-Italic.ttf',
        bolditalics: 'Roboto-Italic.ttf'
      },
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-Italic.ttf'
      },
      Times: {
        normal: 'times.ttf',
        bold: 'timesbd.ttf',
        italics: 'timesi.ttf',
        bolditalics: 'timesbi.ttf'
      },
      WingDing: {
        normal: 'wingding.ttf'
      }
    }
    Vue.prototype.$pdfmake = pdfmake
  }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-pdfmake.js